<template>
  <div class="newlist">
    <div :height="bannerHeight + 'px'">
      <img
        ref="bannerHeight"
        @load="imgLoad"
        style="display: block; width: 100%; height: 100%"
        :src="banner"
        alt=""
      />
    </div>
    <div class="wrapper">
      <p class="newstitle">新闻资讯</p>
      <ul>
        <li
          class="list"
          v-for="(item, index) in list"
          :key="index"
          @mouseover="over(index)"
          @mouseleave="leave"
        >
          <div class="new-time" :class="{ activeTime: index == active }">
            <span>{{ item.mounth }}</span>
            {{ item.year }}
          </div>
          <div class="new-bor" :class="{ activeBor: index == active }"></div>
          <div class="new-xinwen" :class="{ activeXinwen: index == active }">
            <p>{{ item.title }}</p>
            <div class="title">
              {{ item.desc }}
            </div>
            <div
              class="more"
              :class="{ activeMore: index == active }"
              @click="goNewsDetial(item.id)"
            >
              更多详情
            </div>
          </div>
          <img
            v-if="item.img"
            :src="item.img"
            :class="{ activeImg: index == active }"
            alt=""
            width="300px"
            height="1.82rem"
          />
          <!-- <div v-else class="video ">
              <Video
                :videoSrc="item.video"
                :videoPoster="videoPoster"
                :width="w"
                :height="h"
                :autoplay="false"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :controls="true"
                :playWidth="40"
                zoom="contain"
              >
              </Video>
            </div> -->
          <video
            class="video"
            v-else
            :src="item.video"
            :class="{ activeImg: index == active }"
            type="video/mp4"
            controls="false"
            loop="-1"
            @loadeddata="cutOneImg($event)"
          ></video>
        </li>
      </ul>
    </div>
    <footer></footer>
  </div>
</template>
<script>
import { baseUrl } from "../api/index";
import Footer from "@/components/Footer.vue";
// import Video from "@/components/Video.vue";
export default {
  components: {
    Footer,
    // Video,
  },
  data() {
    return {
      active: -1,
      list: [],
      url: baseUrl,
      banner: "",
      bannerHeight: "",
      // w: "100%",
      // h: "100%",
    };
  },
  created() {
    this.getCategoryInfo({ mid: 7 });
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      "resize",
      () => {
        this.imgLoad();
      },
      false
    );
  },
  methods: {
    cutOneImg(event) {
      const videoEle = event.target;
      videoEle.currentTime = 3;
      var canvas = document.createElement("canvas");
      canvas.width = 320;
      canvas.height = 150;
      canvas
        .getContext("2d")
        .drawImage(videoEle, 0, 0, canvas.width, canvas.height); // 给封面图片
      videoEle.poster = canvas.toDataURL("image/png");
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      });
    },
    over(index) {
      this.active = index;
    },
    leave() {
      this.active = -1;
    },
    goNewsDetial(id) {
      this.$router.push("/newsdetial/" + id);
    },
    async getCategoryInfo(params) {
      let res = await this.$api.getCategoryInfo(params);
      this.list = res.data.data.new_list;
      this.list.forEach((ele) => {
        if (ele.img == "") {
          ele.video = this.url + ele.video;
          ele.year = ele.stime.split("-")[0];
          ele.mounth =
            ele.stime.split("-")[1] +
            "." +
            ele.stime.split("-")[2].split(" ")[0];
        } else {
          ele.img = this.url + ele.img;
          ele.year = ele.stime.split("-")[0];
          ele.mounth =
            ele.stime.split("-")[1] +
            "." +
            ele.stime.split("-")[2].split(" ")[0];
        }
      });
      this.banner = this.url + res.data.data.menu_info.banner;
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1200px) {
  .newlist {
    // background-color: #f4f5f9;
    // img {
    //   width: 100%;
    //   height: 460px;
    // }
    .wrapper {
      width: 12rem;
      margin: 0 auto;
      .newstitle {
        position: relative;
        color: #333;
        font-weight: bold;
        font-size: 0.36rem;
        margin-top: 0.5rem;
        text-align: center;
        &::after {
          position: absolute;
          top: 0.56rem;
          left: 6rem;
          margin-left: -0.3rem;
          content: "";
          display: inline-block;
          height: 0.08rem;
          width: 0.6rem;
          border-radius: 0.05rem;
          background: linear-gradient(90deg, #3f66f5, #009fff);
        }
      }
      ul {
        margin-top: 0.75rem;
        .list {
          position: relative;
          // max-width: 11.4rem;
          // height: 1.9rem;
          // min-height: 1.9rem;
          background-color: #fff;
          padding: 0.5rem;
          margin-top: 0.5rem;
          border-radius: 0.05rem;
          display: flex;
          color: #b4b3b3;
          min-height: 170px;
          // 时间
          .new-time {
            width: 0.9rem;
            margin-top: 0.1rem;
            font-size: 0.16rem;
            line-height: 0.3rem;
            transition: 800ms;
            span {
              font-size: 0.26rem;
            }
          }
          .activeTime {
            width: 1rem;
            span {
              font-size: 0.3rem;
              color: black;
            }
          }
          // ----------
          .new-bor {
            width: 0.7rem;
            margin-top: 0.25rem;
            border-top: 1px solid #bbbbbb;
            transition: 800ms;
          }
          .activeBor {
            width: 1rem;
            border-top: 1px solid black;
          }
          // 新闻
          .new-xinwen {
            width: 6.3rem;
            margin-left: 0.3rem;
            color: #8d8f98;
            transition: 800ms;
            .title {
              width: 5.6rem;
              font-size: 0.14rem;
              line-height: 0.25rem;
            }

            p {
              margin-bottom: 0.1rem;
              font-size: 0.23rem;
              font-weight: 500;
              color: #555557;
            }

            // 更多
            .more {
              margin-top: 0.2rem;
              width: 1.2rem;
              height: 0.32rem;
              background: #595a5b;
              text-align: center;
              color: #fff;
              line-height: 0.32rem;
              cursor: pointer;
            }
            .activeMore {
              background: #0d7ef0;
            }
          }
          .activeXinwen {
            width: 6.3rem;
            margin-left: 0.3rem;
            color: black;
          }
          // 图片
          img {
            position: absolute;
            right: 0.3rem;
            top: 0.3rem;
            width: 2.76rem;
            height: 1.82rem;
            margin-left: 1rem;
          }
          .video {
            position: absolute;
            right: 0.3rem;
            top: 0.3rem;
            width: 2.76rem;
            height: 1.82rem;
            margin-left: 1rem;
          }
          .activeImg {
            position: absolute;
            right: 0.3rem;
          }
        }
      }
      //   .moreDetial{
      //   width: 1.5rem;
      //   height: 0.4rem;
      //   padding: 0.1rem;
      //   font-size: 0.18rem;
      //   box-sizing: border-box;
      //   text-align: center;
      //   margin: .3rem auto;
      //   background: #595a5b;
      //   color: #fff;
      //   &:hover{
      //     background: #0d7ef0;
      //     cursor: pointer;
      //   }
      // }
    }
  }
}

@media screen and (max-width: 750px) {
  /*自定义video样式*/

 video::-webkit-media-controls-panel {
  width: calc(100% + 32px);
  background: #00000055;
}
video::-webkit-media-controls-timeline {
   display: none;
}
video::-webkit-media-controls {
  overflow: hidden !important;
}
video::-webkit-media-controls-enclosure {
  width: calc(100% + 15px);
  margin-left: auto;
}
  .newlist {
    min-height: 5rem;
    // background-color: #f4f5f9;
    // img {
    //   width: 100%;
    //   height: 1.5rem;
    // }
    .wrapper {
      width: 3.2rem;
      margin: 0 auto;
      .newstitle {
        position: relative;
        color: #333;
        font-weight: bold;
        font-size: 0.12rem;
        margin-top: 0.1rem;
        text-align: center;
        &::after {
          position: absolute;
          top: 0.2rem;
          left: 1.75rem;
          margin-left: -0.3rem;
          content: "";
          display: inline-block;
          height: 0.04rem;
          width: 0.3rem;
          border-radius: 0.025rem;
          background: linear-gradient(90deg, #3f66f5, #009fff);
        }
      }
      ul {
        margin-top: 0.2rem;
        .list {
          position: relative;
          background-color: #fff;
          padding: 0.1rem;
          margin-top: 0.1rem;
          border-radius: 0.05rem;
          display: flex;
          color: #b4b3b3;
          min-height: 0.7rem;
          // 时间
          .new-time {
            width: 0.15rem;
            margin-top: 0.1rem;
            font-size: 0.1rem;
            line-height: 0.15rem;
            transition: 800ms;
            span {
              font-size: 0.1rem;
            }
          }
          // ----------
          .new-bor {
            width: 0.25rem;
            margin-top: 0.16rem;
            border-top: 1px solid #bbbbbb;
            transition: 800ms;
            margin-left: 0.15rem;
          }
          // 新闻
          .new-xinwen {
            width: 3.3rem;
            margin-left: 0.08rem;
            color: #8d8f98;
            transition: 800ms;
            .title {
              width: 1.4rem;
              font-size: 0.08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              word-break: break-all;
              line-height: 0.11rem;
            }

            p {
              // margin-bottom: 0.03rem;
              font-size: 0.09rem;
              font-weight: 500;
              color: #555557;
            }

            // 更多
            .more {
              margin-top: 0.1rem;
              width: 0.34rem;
              height: 0.16rem;
              background: #595a5b;
              text-align: center;
              color: #fff;
              cursor: pointer;
              font-size: 0.06rem;
              line-height: 0.16rem;
            }
          }
          // 图片
          img {
            position: absolute;
            right: 0.15rem;
            top: 0.33rem;
            width: 0.85rem;
            height: 0.5rem;
            margin-left: 1rem;
          }
          .video {
            position: absolute;
            right: 0.15rem;
            top: 0.33rem;
            width: 0.85rem;
            height: 0.5rem;
            margin-left: 1rem;
          }
        }
      }
    }
  }
}
</style>